import React, { useEffect, useState } from "react";
import ApiAgent from "../../core/api/api.agent";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Card, Divider } from "@mui/material";
import SplitNumber from "./_Components/SplitNumber";
import {
  IconPlus,
  IconCoinBags,
  IconCoins,
  IconTickets,
  IconWallet,
  IconChart,
} from "../../_metronic/css/icons";

export function DashboardPage() {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({});
  const [loadingData, setLoadingData] = useState(false);

  // export const DashboardPage = (props) => {

  // let history = useHistory();
  // let location = useLocation();

  // console.log("DashboardPage");
  useEffect(() => {
    ApiAgent.getAgentById("").then((rest) => {
      rest.data.agentId == 0 && navigate("/agentProfile");
    });
  }, []);
  useEffect(() => {
    (async () => {
      setLoadingData(true);
      try {
        const data = await ApiAgent.getAgentDashboard();
        setDashboardData(data.data);
        setLoadingData(false);

        // console.log("dashboardData", data.data);
      } catch (error) {
        setLoadingData(false);
        //console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => {};
  }, []);
  // let { id } = useParams();

  // console.log("location.href", location, location)

  // if (location.search && location?.search?.split("=").length >= 2) {

  //   var tt= location.search;
  //   console.log("DashboardPage3", location.search.split("=")[1])
  //   //ServiceStorage.clearToken();
  //   ServiceStorage.setToken(location.search.split("=")[1], null);
  //   ServiceApi.setToken();

  //   history.push('/dashboard');

  // }

  return (
    <>
      <Row>
        <Col md="4" className="mb-4 mb-md-0">
          <Card className="bg-primary text-white rounded-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <IconWallet className="opacity-75" width="40" />

                <h4 className="fw-bold mt-4 me-3">کیف پول</h4>
              </div>

              <div className="mt-5 mb-3 d-flex align-items-center">
                <IconCoinBags width="18px" className="ms-1" />
                <div className=" mx-1">موجودی</div>

                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber number={dashboardData?.walletAmount} />
                    </div>
                    تومان
                  </>
                )}
              </div>
              <Link to="/rechargeWallet" className="btn btn-outline-white py-2">
                <IconPlus width="18px" className="ms-1" />
                شارژ کیف پول
              </Link>
            </div>
          </Card>
        </Col>
        <Col md="4" className="mb-4 mb-md-0">
          <Card className="bg-info text-white h-100 rounded-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <IconChart className="opacity-75" width="40px" />

                <h4 className="fw-bold mt-4 me-3">فروش ماه جاری </h4>
              </div>
              <div className="mt-5 mb-3 d-flex align-items-center">
                <IconCoins width="18px" className="ms-1" />
                <div>مبلغ</div>
                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber
                        number={dashboardData?.currentMonthSalesAmount}
                      />
                    </div>
                    تومان
                  </>
                )}
              </div>
              <div className="d-flex align-items-center">
                <IconTickets width="18px" className="ms-1" />
                <div>تعداد</div>
                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber
                        number={dashboardData?.currentMonthSalesCount}
                      />
                    </div>
                    تفریح
                  </>
                )}
              </div>
            </div>
          </Card>
        </Col>
        <Col md="4" className="mb-4 mb-md-0">
          <Card className="bg-success text-white h-100 rounded-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <IconChart className="opacity-75" width="40px" />
                <h4 className="fw-bold mt-4 me-3">فروش ماه گذشته </h4>
              </div>
              <div className="mt-5 mb-3  d-flex align-items-center">
                <IconCoins width="18px" className="ms-1" />
                <div>مبلغ</div>

                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber
                        number={dashboardData?.lastMonthSalesAmount}
                      />
                    </div>
                    تومان
                  </>
                )}
              </div>
              <div className="d-flex align-items-center">
                <IconTickets width="18px" className="ms-1" />
                <div>تعداد</div>

                {loadingData ? (
                  <div
                    className="opacity-75 mx-1"
                    style={{ lineHeight: "26px" }}
                  >
                    در حال دریافت اطلاعات
                  </div>
                ) : (
                  <>
                    <div className="fw-bold fs-large mx-1">
                      <SplitNumber
                        number={dashboardData?.lastMonthSalesCount}
                      />
                    </div>
                    تفریح
                  </>
                )}
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}
